//Class qui contient les fontions par défaut des scènes.
import Phaser from 'phaser'
import { tags } from '../consts/Tags.js'
import Popup from '../prefabs/popups/Popup.js';
import { Colors } from '../consts/Colors.js';

export default class AbstractScene extends Phaser.Scene {

    //Initialisation par défaut, à ajouter dans tous les initialisation
    //Data contient les info des transitions (cf onCompleteHandlerTransitionOUT)
    _init(data) {
        console.log('Start :', this.scene.key, data);
        this.data = {};

        this.game.data.sceneRunning = this.scene.key;

        if (data) {
            // Data à faire passer au besoin
        }
    }

    //Preload de la scene par défaut, initialise les variables utiles
    _preload() {

        this.width = this.cameras.main.width; //Largeur de l'écran
        this.height = this.cameras.main.height; //Hauter de l'écran

        this.dim = this.height * 0.05; //Variable pour adapter les images à la hauteur
        this.ratio = Math.min(this.width / 1920, this.height / 1080); //Ratio de l'écran
    }

    nextScene() {
        var sceneInfo = this.game.data[this.game.data.sceneRunning];
        this.scene.start(sceneInfo.next, this.data);
    }

    clone(element) {
        var clone = Phaser.Utils.Objects.Clone(element)
        this.add.existing(clone)
        return clone
    }

    createTextElement(x, y, element) {
        let txt = this.add.rexTagText(x, y, element.text, {
            fontSize: element.config.size,
            fontFamily: element.config.fontFamily,
            align: element.config.align,
            color: element.config.color,
            backgroundColor: element.config.backColor,
            wordWrap: { width: element.config.width },
            tags: tags
        }).setOrigin(element.config.origin.x, element.config.origin.y);
        return txt
    }

    tweenTextColor(target, to, duration) {
        this.tweenPropertyColorOnUpdate(target.style, 'color', to, duration, (color => {
            target.setColor(Phaser.Display.Color.RGBToString(color.r, color.g, color.b, 0, '#'));
        }));
    }

    tweenShapeColor(target, to, duration) {
        this.tweenPropertyColorOnUpdate(target, 'fillColor', to, duration);
    }

    tweenImageTint(target, to, duration) {
        this.tweenPropertyColorOnUpdate(target, 'tint', to, duration);
    }

    tweenPropertyColorOnUpdate(target, property, to, duration, funcToExecOnUPdate = null) {
        let colorFrom = Phaser.Display.Color.ValueToColor(target[property]);
        let colorTo = Phaser.Display.Color.ValueToColor(to);
        this.tweens.add({
            targets: colorFrom,
            r: colorTo.red,
            g: colorTo.green,
            b: colorTo.blue,
            duration: duration,
            ease: 'Power2',
            onUpdate: () => {
                target[property] = Phaser.Display.Color.GetColor(colorFrom.r, colorFrom.g, colorFrom.b);
                if (funcToExecOnUPdate) {
                    funcToExecOnUPdate(colorFrom);
                }
            },
        })
    }

    addBlueRect(){
        this.blueRect = this.add.rectangle(0, 0, this.width, this.height, Colors.Elmt.DarkBlue).setOrigin(0, 0)
        this.blueRect.setInteractive()
        this.blueRect.depth = 10
        this.tweens.add({
            targets: this.blueRect,
            alpha: 0.5,
            duration: 300
        })
    }

    hideBlueRect(){
        this.tweens.add({
            targets: this.blueRect,
            alpha: 0,
            duration: 300,
            onComplete: () => {
                this.blueRect.destroy()
            }
        })
    }

    addPopup({text, x = this.width / 2, y = this.height / 2, width, height, endFunc}){
        this.addBlueRect()

        this.popup = new Popup(this, x, y, { text: text, width: width, height: height })
        this.popup.depth = 10
        this.popup.setClickFunction(() => {
            this.hideBlueRect()
            this.popup.hide(() => {
                endFunc()
            })
        })


        this.popup.show()
    }
}